/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EnhancedConfigurationDto
 */
export interface EnhancedConfigurationDto {
    /**
     * 
     * @type {string}
     * @memberof EnhancedConfigurationDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof EnhancedConfigurationDto
     */
    configurationType?: string;
    /**
     * 
     * @type {string}
     * @memberof EnhancedConfigurationDto
     */
    scope?: string;
    /**
     * 
     * @type {string}
     * @memberof EnhancedConfigurationDto
     */
    tenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof EnhancedConfigurationDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof EnhancedConfigurationDto
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof EnhancedConfigurationDto
     */
    version?: number;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof EnhancedConfigurationDto
     */
    configurationData?: { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof EnhancedConfigurationDto
     */
    metadata?: { [key: string]: any; };
    /**
     * 
     * @type {boolean}
     * @memberof EnhancedConfigurationDto
     */
    active?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EnhancedConfigurationDto
     */
    createdBy?: string;
    /**
     * 
     * @type {string}
     * @memberof EnhancedConfigurationDto
     */
    updatedBy?: string;
    /**
     * 
     * @type {Date}
     * @memberof EnhancedConfigurationDto
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof EnhancedConfigurationDto
     */
    updatedAt?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof EnhancedConfigurationDto
     */
    runtimeConfigurable?: boolean;
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof EnhancedConfigurationDto
     */
    fieldMetadata?: Array<{ [key: string]: any; }>;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof EnhancedConfigurationDto
     */
    schema?: { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof EnhancedConfigurationDto
     */
    examples?: { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof EnhancedConfigurationDto
     */
    typeMetadata?: { [key: string]: any; };
    /**
     * 
     * @type {boolean}
     * @memberof EnhancedConfigurationDto
     */
    _default?: boolean;
}

/**
 * Check if a given object implements the EnhancedConfigurationDto interface.
 */
export function instanceOfEnhancedConfigurationDto(value: object): value is EnhancedConfigurationDto {
    return true;
}

export function EnhancedConfigurationDtoFromJSON(json: any): EnhancedConfigurationDto {
    return EnhancedConfigurationDtoFromJSONTyped(json, false);
}

export function EnhancedConfigurationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnhancedConfigurationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'configurationType': json['configurationType'] == null ? undefined : json['configurationType'],
        'scope': json['scope'] == null ? undefined : json['scope'],
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'version': json['version'] == null ? undefined : json['version'],
        'configurationData': json['configurationData'] == null ? undefined : json['configurationData'],
        'metadata': json['metadata'] == null ? undefined : json['metadata'],
        'active': json['active'] == null ? undefined : json['active'],
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'updatedBy': json['updatedBy'] == null ? undefined : json['updatedBy'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'runtimeConfigurable': json['runtimeConfigurable'] == null ? undefined : json['runtimeConfigurable'],
        'fieldMetadata': json['fieldMetadata'] == null ? undefined : json['fieldMetadata'],
        'schema': json['schema'] == null ? undefined : json['schema'],
        'examples': json['examples'] == null ? undefined : json['examples'],
        'typeMetadata': json['typeMetadata'] == null ? undefined : json['typeMetadata'],
        '_default': json['default'] == null ? undefined : json['default'],
    };
}

export function EnhancedConfigurationDtoToJSON(json: any): EnhancedConfigurationDto {
    return EnhancedConfigurationDtoToJSONTyped(json, false);
}

export function EnhancedConfigurationDtoToJSONTyped(value?: EnhancedConfigurationDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'configurationType': value['configurationType'],
        'scope': value['scope'],
        'tenantId': value['tenantId'],
        'name': value['name'],
        'description': value['description'],
        'version': value['version'],
        'configurationData': value['configurationData'],
        'metadata': value['metadata'],
        'active': value['active'],
        'createdBy': value['createdBy'],
        'updatedBy': value['updatedBy'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
        'runtimeConfigurable': value['runtimeConfigurable'],
        'fieldMetadata': value['fieldMetadata'],
        'schema': value['schema'],
        'examples': value['examples'],
        'typeMetadata': value['typeMetadata'],
        'default': value['_default'],
    };
}

